import { defineStore } from "pinia";
import { consola } from "consola";
import type { Promotion } from "@/types/promotion";

interface RootState {
  isLoading: boolean;
  promotions: Promotion[];

}

export const usePromotionStore = defineStore("promotion", () => {
  const state = reactive<RootState>({
    isLoading: false,
    promotions: []
  });

  async function fetchPromotions() {
    state.isLoading = true;
    try {
      const { data } = await useFetch<Promotion[]>("/v2/promotions");

      const promotions = data.value as Promotion[];

      state.promotions = promotions.map((promotion) => {
        return {
          ...promotion,
          image: promotion.image.startsWith("http") ? promotion.image : `/storage${promotion.image}`
        };
      }) as Promotion[];

    } catch (error) {
      consola.error("/promotions an error has occur:", error);
    } finally {
      state.isLoading = false;
    }
  }

  return {
    state,
    fetchPromotions
  };
});
